<script setup>
import {defineProps} from "vue";
import useHelper from "@/composables/useHelper";

const props = defineProps({
    content: Object,
    index: Number
});

const {computeButtonClass} = useHelper();
</script>

<template>
    <div class="flex w-11/12 items-center">
        <div class="h-2 flex-1 rounded-full bg-slate-200 overflow-hidden ltr:mr-5 rtl:ml-5">
            <div class="w-full bg-gray-200 rounded-full h-2.5">
                <div class="h-2.5 rounded-full" :class="computeButtonClass(props.content)"
                     :style="{'width': Math.round(props.content.progress)+'%'}"></div>
            </div>
        </div>
        <p class="text-sm font-semibold text-slate-600 pl-1">{{ Math.round(props.content.progress) }}%</p>
    </div>
</template>


